/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    ChunkedListBase,
    ChunkedListBaseFromJSON,
    ChunkedListBaseFromJSONTyped,
    ChunkedListBaseToJSON,
    StationInfo,
    StationInfoFromJSON,
    StationInfoFromJSONTyped,
    StationInfoToJSON,
    StationInfoListChunkAllOf,
    StationInfoListChunkAllOfFromJSON,
    StationInfoListChunkAllOfFromJSONTyped,
    StationInfoListChunkAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationInfoListChunk
 */
export interface StationInfoListChunk {
    /**
     * 
     * @type {number}
     * @memberof StationInfoListChunk
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof StationInfoListChunk
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof StationInfoListChunk
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof StationInfoListChunk
     */
    pageCount: number;
    /**
     * 
     * @type {Array<StationInfo>}
     * @memberof StationInfoListChunk
     */
    chunk: Array<StationInfo>;
}

export function StationInfoListChunkFromJSON(json: any): StationInfoListChunk {
    return StationInfoListChunkFromJSONTyped(json, false);
}

export function StationInfoListChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationInfoListChunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'totalCount': json['totalCount'],
        'pageCount': json['pageCount'],
        'chunk': ((json['chunk'] as Array<any>).map(StationInfoFromJSON)),
    };
}

export function StationInfoListChunkToJSON(value?: StationInfoListChunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'totalCount': value.totalCount,
        'pageCount': value.pageCount,
        'chunk': ((value.chunk as Array<any>).map(StationInfoToJSON)),
    };
}


